<div class="flex flex-col gap-1">
  @if (label()) {
    <label class="font-semibold text-[0.8125rem] text-[var(--color-text-primary)]" [for]="label()">
      {{ isRequired(formControlGeneral()) ? label() + '*' : label() }}
    </label>
  }
  <input
    [id]="label()"
    [type]="type()"
    [formControl]="getInputGeneral()"
    [placeholder]="placeholder()"
    [maxlength]="maxlength() > 0 ? maxlength() : 524288"
    [pattern]="pattern()"
    [mask]="mask()"
    [prefix]="prefix()"
    [suffix]="suffix()"
    [thousandSeparator]="thousandSeparator()"
    [allowNegativeNumbers]="allowNegativeNumbers()"
    class="w-full px-5 py-2.5 text-[0.9375rem] border border-[var(--color-border)] rounded-[0.875rem] bg-[var(--color-bg-primary)] text-[var(--color-text-primary)] shadow-[0_0.0625rem_0.1875rem_rgba(0,0,0,0.1)] outline-none transition-all duration-300 placeholder:text-[var(--color-text-muted)] focus:border-[var(--color-border-focus)] focus:shadow-[0_0_0_0.1875rem_rgba(1,116,253,0.15)]"
    [class.border-[var(--color-text-error)]!]="formControlGeneral()?.invalid && (formControlGeneral()?.touched || formControlGeneral()?.dirty)"
    [class.bg-[var(--color-bg-error)]!]="formControlGeneral()?.invalid && (formControlGeneral()?.touched || formControlGeneral()?.dirty)"
  />
  @if (formControlGeneral()?.invalid && (formControlGeneral()?.touched || formControlGeneral()?.dirty)) {
    <span class="text-[0.8125rem] text-[var(--color-text-error)] mt-1">{{ getErrorMessage() }}</span>
  }
</div>
